import TypeaheadContainer from "../../../../../Components/Forms&Table/Forms/FormWidgets/Typeahead/TypeaheadContainer";

const Typeahead = () => {
  return <TypeaheadContainer />;
};

export default Typeahead;
